import { Injectable } from '@angular/core';
import { UserDataModel } from '@modules/auth';

declare let pendo: any;

@Injectable({
  providedIn: 'root'
})
export class PendoService {
  private pendoInitialized = false;

  constructor() {}

  initialize(): void {
    if (this.pendoInitialized || typeof pendo === 'undefined') {
      return;
    }

    // Initialize with anonymous visitor for logged-out users
    pendo.initialize({
      visitor: {
        id: 'anonymous'
      },
      account: {
        id: 'liv2bme-app'
      }
    });

    this.pendoInitialized = true;
  }

  identifyUser(user: UserDataModel): void {
    if (typeof pendo === 'undefined') {
      console.warn('Pendo is not loaded');
      return;
    }

    const visitorData = {
      id: user.id || user.userId,
      email: user.email,
      full_name: this.getFullName(user),
      role: this.getUserRole(user),
      grade: user.grade,
      state: user.state,
      survey_completed: user.isSurveyTaken
    };

    const accountData = {
      id: 'liv2bme-app',
      name: 'Liv2BMe Social Media Platform'
    };

    pendo.initialize({
      visitor: visitorData,
      account: accountData
    });

    this.pendoInitialized = true;
  }

  logout(): void {
    if (typeof pendo === 'undefined') {
      return;
    }

    // Reset to anonymous visitor
    pendo.initialize({
      visitor: {
        id: 'anonymous'
      },
      account: {
        id: 'liv2bme-app'
      }
    });
  }

  trackEvent(eventName: string, metadata?: any): void {
    if (typeof pendo === 'undefined') {
      return;
    }

    pendo.track(eventName, metadata);
  }

  private getFullName(user: UserDataModel): string {
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    return `${firstName} ${lastName}`.trim() || user.userName || 'Unknown User';
  }

  private getUserRole(user: UserDataModel): string {
    if (user.roles && user.roles.length > 0) {
      return user.roles.includes('SuperAdmin') ? 'admin' : 
             user.roles.includes('BasicUser') ? 'user' : 
             user.roles[0].toLowerCase();
    }
    return 'user';
  }
}